import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { XCircle, ArrowLeft } from 'lucide-react';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
            <XCircle className="h-8 w-8 text-muted-foreground" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Paiement annulé</h1>
          <p className="text-muted-foreground mb-6">
            Votre paiement a été annulé. Aucun montant n'a été prélevé.
          </p>
          <div className="space-y-3">
            <Button onClick={() => navigate('/subscription')} className="w-full">
              Réessayer
            </Button>
            <Button variant="outline" onClick={() => navigate('/feed')} className="w-full">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour au fil
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionCancelPage;
